import styled from "styled-components";

export const HeaderWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const StyledName = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
`;
export const Plag6Wrap = styled.div`
  height: 100%;
`;
export const Header = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 25px;
  /* identical to box height, or 112% */
  display: flex;
  align-items: center;

  /* Текст/#333333 текст|кнопки */
  color: #333333;
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;
export const PluginsWrap = styled.div`
  display: flex;
  flex-direction: raw;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 15px 10px;
  margin-top: 15px;
`;
export const RadialWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  height: 90%;
  align-items: center;
  text-align: center;
  // border: 1px solid black;

  & span {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 28px;
    color: #333333;
  }
`;
